<template>
  <span>
    {{ lastDigitsChaveAcesso }}
    <v-btn icon left small @click="copyChaveAcesso">
      <v-icon small>mdi-content-copy</v-icon>
    </v-btn>
  </span>
</template>

<script>
export default {
  props: {
    notaFiscal: {
      type: Object,
      required: true,
    },
    showDigits: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    lastDigitsChaveAcesso() {
      return this.notaFiscal.chaveAcesso
        ? this.notaFiscal.chaveAcesso.slice(-this.showDigits)
        : '';
    },
  },
  methods: {
    copyChaveAcesso() {
      if (this.notaFiscal.chaveAcesso) {
        navigator.clipboard.writeText(this.notaFiscal.chaveAcesso);
        this.$toast.info('Chave de acesso copiada para a área de transferência');
      }
    },
  },
};
</script>
